import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AdminService } from 'src/app/services/admin.service';
import { AuthService } from 'src/app/services/auth.service';
import { PlansService } from 'src/app/services/plans.service';
import { VendorService } from 'src/app/services/vendor.service';
import { UtilsService } from 'src/app/utils.service';
import { NeojobzHeaderComponent } from '../../neojobz-header/neojobz-header.component';


@Component({
  selector: 'app-header-latest',
  standalone: true,
  imports: [CommonModule,NeojobzHeaderComponent],
  templateUrl: './header-latest.component.html',
  styleUrl: './header-latest.component.scss'
})
export class HeaderLatestComponent {

  isLoggedIn = false;
  freePlan: any;
  activePath: string = '';

  private loginStatusSubscription: Subscription;
  data: any = {}
  constructor(
    private router: Router,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef,
    private vendorService: VendorService,
    private plansService: PlansService,
    private adminService: AdminService,
    private utilsService: UtilsService,


  ) {
    this.getPlans()
  }

  /* ngOnInit(){
    this.loginStatusSubscription = this.authService.getLoginStatus().subscribe(status => {
      this.isLoggedIn = status;
      this.cdRef.detectChanges(); // Trigger change detection
      console.log("isLoggedIn === ", this.isLoggedIn)
    });
  } */
  ngOnInit() {
    this.activePath = this.router.url; // set initial path

    this.loginStatusSubscription = this.authService.getLoginStatus().subscribe(status => {
      this.isLoggedIn = status;
      this.cdRef.detectChanges();
      console.log("isLoggedIn === ", this.isLoggedIn);
    });

    // Listen for route changes
    this.router.events.subscribe((event: any) => {
      if (event?.url) {
        this.activePath = event.url;
      }
    });

    this.utilsService.profileActionData.subscribe((data: any) => {
      this.data = data.profileData;
      console.log("RRRRR", data);
      //this.setAgentProfile(this.adminData); // Move it here
    });
  }
  logout(): void {
    this.authService.logout();
    this.vendorService.clearData();
    this.router.navigate(['/']); // Redirect to login page or home page after logout
  }

  goTo(link: any) {
    this.router.navigate([link])
  }

  goToFreePlan(plan: any) {
    this.plansService.selectedPlan = plan; // Store the selected plan object
    this.router.navigate(['/product-details']);
    console.log("plan check", plan)
  }

  getPlans() {
    let reqObj = {};
    this.adminService.getPlans(reqObj).subscribe((response) => {
      if (response.statusCode === 200) {
        const jobsPlans = response.data.plans.JOBS;
        console.log("JOBS Plans:", jobsPlans);
        this.freePlan = jobsPlans.find(plan => plan.plan_type === 'F');
        console.log("CCCCC", this.freePlan)
      }
    });
  }


 goToDashboard() {
  const role = this.data.role;

  console.log("role", role);

  switch (role) {
    case 'VENDOR':
      this.router.navigate(['vendor/jobs-dashboard']);
      break;

    case 'VENDOR_EMP':
      this.router.navigate(['/vendor/employee/console']);
      break;

    case 'AGENT':
      this.router.navigate(['/admin/agents-console']);
      break;

    case 'INTERVIEWER':
      this.router.navigate(['/interviewer']);
      break;

    case 'USER':
      this.router.navigate(['job-seeker/new-dashboard']);
      break;

    default:
      console.warn('Unknown role:', role);
      break;
  }
}



}